module.exports = __webpack_public_path__ + "static/media/empty-logo.13d90878.svg";